import { ServicesQuery } from './services-query';
import { ServiceCategoriesQuery } from './service-categories-query';
export var endpoints = {
    servicesQuery: new ServicesQuery(),
    serviceCategoriesQuery: new ServiceCategoriesQuery(),
};
